import { render } from "./HomeModalDeleteImage.vue?vue&type=template&id=e121e834"
import script from "./HomeModalDeleteImage.vue?vue&type=script&lang=js"
export * from "./HomeModalDeleteImage.vue?vue&type=script&lang=js"
script.render = render

export default script